import { getGlacierTimeline, STAGES } from '@/constants/glacier';
import EfScrollAni from '@/efscrollani';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import getHostApi from '@/utils/singUtil/getHostApi';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import CrowdFunding from './crowdfunding';
import Detail from './detail';
import Treaser from './treaser';

export default function GlacierPC({ productDetail, resProductCatagory, callBackTheme, supportData, ecoflowflag, ecoflowflag2, ecoflowflag3 }: any) {
    const { useRef, getSystemTime, useState, useRouter } = useGlobal();
    const router = useRouter();
    const { locale, query } = router;
    const isTest = process.env.NEXT_PUBLIC_MODY === 'test';
    const TIMELINE = getGlacierTimeline(locale, isTest);
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'];

    // 倒计时三个时间段
    // 0616 @陈琨 欧洲六站的阶段逻辑顺序改变：
    // 正常时间线： 预热[可能不存在] > 早鸟[可能不存在] > 详情
    // 欧洲六站时间线： 预热 > 详情 > 早鸟（夏季促销早鸟 > 正常早鸟）
    const teaserTime: number = new Date(TIMELINE?.teaser || 0).getTime();
    const crowdfundingTime: number = new Date(TIMELINE?.crowdfunding || 0).getTime();
    const stage2Time: number = new Date(TIMELINE?.crowdfunding_stage2 || 0).getTime();
    const detailTime: number = new Date(TIMELINE?.detail || 0).getTime();
    const endTimeStamp: number = EU_SITES.includes(locale) ? new Date(TIMELINE?.crowdfunding_stage2 || 0).getTime() : new Date(TIMELINE?.detail || 0).getTime();

    // 计时器
    const timer: any = useRef(null);

    const props = {
        productDetail,
        resProductCatagory,
        nowSysTime: serverTimeStamp.current,
        crowdfundingTimeline: {
            stage1: crowdfundingTime,
            stage2: stage2Time,
            end: endTimeStamp,
        },
        supportData,
        ecoflowflag2,
    };

    const [curStage, setCurStage] = useState(() => {
        // 测试环境serverTimeStamp获取会异常， 异常时纠正
        if (serverTimeStamp.current < 1000000) {
            serverTimeStamp.current = new Date().getTime();
        }
        // 最后一个时间阶段： 详情阶段 欧洲六站则为早鸟阶段
        if (EU_SITES.includes(locale)) {
            if (ecoflowflag3 || (serverTimeStamp.current >= crowdfundingTime && crowdfundingTime !== 0)) {
                return STAGES.CRODWFUNDING;
            }
        } else {
            if (ecoflowflag2 || (serverTimeStamp.current >= detailTime && detailTime !== 0)) {
                return STAGES.DETAIL;
            }
        }
        // 倒数第二个时间阶段
        if (EU_SITES.includes(locale)) {
            // 详情阶段
            if (ecoflowflag2 || (serverTimeStamp.current >= detailTime && detailTime !== 0)) {
                return STAGES.DETAIL;
            }
        } else {
            // 众筹阶段
            if (ecoflowflag3 || (serverTimeStamp.current >= crowdfundingTime && crowdfundingTime !== 0)) {
                return STAGES.CRODWFUNDING;
            }
        }
        // 预热阶段
        if (ecoflowflag || (serverTimeStamp.current >= teaserTime && teaserTime !== 0)) {
            return STAGES.TEASER;
        }
        return STAGES.UNKNOWN;
    });

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    useEffect(() => {
        // 测试环境异常
        if (serverTimeStamp?.current < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);
                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                } catch (e) {
                    console.log(e);
                }
            })();
        }

        // 倒计时结束完成之前一直执行定时器任务
        if (
            (serverTimeStamp.current < endTimeStamp && endTimeStamp !== 0) ||
            (serverTimeStamp.current < crowdfundingTime && crowdfundingTime !== 0 && endTimeStamp === 0)
        ) {
            timer.current = setInterval(() => {
                serverTimeStamp.current += 1000;
                // 最后一个阶段： 详情阶段 欧洲六站则为早鸟
                if (!EU_SITES.includes(locale)) {
                    if (ecoflowflag2 || (serverTimeStamp.current >= detailTime && detailTime !== 0)) {
                        curStage !== STAGES.DETAIL && setCurStage(STAGES.DETAIL);
                        // 倒计时结束
                        return clearInterval(timer.current);
                    }
                } else {
                    if (ecoflowflag3 || (serverTimeStamp.current >= crowdfundingTime && crowdfundingTime !== 0)) {
                        curStage !== STAGES.CRODWFUNDING && setCurStage(STAGES.CRODWFUNDING);
                        // 倒计时结束
                        return clearInterval(timer.current);
                    }
                }
                if (!EU_SITES.includes(locale)) {
                    // 众筹阶段
                    if (ecoflowflag3 || (serverTimeStamp.current >= crowdfundingTime && crowdfundingTime !== 0)) {
                        if (endTimeStamp === 0) {
                            clearInterval(timer.current);
                        }
                        return curStage !== STAGES.CRODWFUNDING && setCurStage(STAGES.CRODWFUNDING);
                    }
                } else {
                    if (ecoflowflag2 || (serverTimeStamp.current >= detailTime && detailTime !== 0)) {
                        if (endTimeStamp === 0) {
                            clearInterval(timer.current);
                        }
                        return curStage !== STAGES.DETAIL && setCurStage(STAGES.DETAIL);
                    }
                }
                // 预热阶段
                if (ecoflowflag || (serverTimeStamp.current >= teaserTime && teaserTime !== 0)) {
                    if (endTimeStamp === 0 && crowdfundingTime === 0) {
                        clearInterval(timer.current);
                    }
                    return curStage !== STAGES.TEASER && setCurStage(STAGES.TEASER);
                }
                // 预热开始前阶段: 有预热、无预热有众筹、无预热无众筹
                if (
                    (serverTimeStamp.current < teaserTime && teaserTime !== 0) ||
                    (serverTimeStamp.current < crowdfundingTime &&
                        teaserTime === 0 &&
                        (!EU_SITES.includes(locale) || (EU_SITES.includes(locale) && detailTime === 0)) &&
                        crowdfundingTime !== 0) ||
                    (serverTimeStamp.current < endTimeStamp &&
                        teaserTime === 0 &&
                        ((crowdfundingTime === 0 && !EU_SITES.includes(locale)) || (detailTime === 0 && EU_SITES.includes(locale))) &&
                        endTimeStamp !== 0)
                ) {
                    return router.push('/404');
                }
            }, 1000);
        } else {
            clearInterval(timer.current);
        }
        if (typeof window !== 'undefined') {
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    if (typeof window !== 'undefined') {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        callBackTheme(curStage === STAGES.CRODWFUNDING ? 'white' : 'black');
        return () => {
            AniContainer.destroy();
        };
    }, []);

    useEffect(() => {
        if (query?.debug) {
            setCurStage(Number(query?.debug));
        }
    }, [query?.debug]);

    return (
        <>
            {curStage === STAGES.TEASER && <Treaser />}
            {curStage === STAGES.CRODWFUNDING && <CrowdFunding {...props} />}
            {curStage === STAGES.DETAIL && <Detail />}
        </>
    );
}
